import styled from "styled-components";

export const TermsList = styled.ul`  
    ol {
      counter-reset: orderedListWithBrackets;

        li {
          list-style: none;
          counter-increment: orderedListWithBrackets;
          margin-bottom: 10px;
          &::marker {
            content: "(" counter(orderedListWithBrackets) ") ";
          }
        }
        
        ul {
          padding-left: 20px;    
          margin-top: 5px;
          
          li {
            margin-bottom: 5px;
            
            &::marker {
            content: "⮚ ";
            }
          }
        }
      }
`;